import React, { useState } from "react";

export default function Client() {
  // Step 1: All reviews data
  const reviews = [
    {
      stars: 5,
      text: "It was truly a pleasure working with your team. The quality and professionalism exceeded my expectations.",
      name: "Noman Ashraf",
      location: "Lahore",
    },
    {
      stars: 4,
      text: "Great experience overall! The design process was smooth and communication was excellent.",
      name: "Ayesha Malik",
      location: "Karachi",
    },
    {
      stars: 5,
      text: "Amazing work! They delivered exactly what I wanted and even before the deadline.",
      name: "Ali Raza",
      location: "Islamabad",
    },
    {
      stars: 5,
      text: "The attention to detail was outstanding. I’d definitely recommend them to others.",
      name: "Fatima Khan",
      location: "Multan",
    },
    {
      stars: 4,
      text: "They handled everything professionally and made the process very easy for us.",
      name: "Usman Tariq",
      location: "Faisalabad",
    },
  ];

  // Step 2: State to track current review
  const [index, setIndex] = useState(0);

  // Step 3: Functions to move between reviews
  const nextReview = () => {
    setIndex((prevIndex) => (prevIndex + 1) % reviews.length);
  };

  const prevReview = () => {
    setIndex((prevIndex) => (prevIndex - 1 + reviews.length) % reviews.length);
  };

  const current = reviews[index];

  return (
    <div className="flex flex-col items-center justify-center w-full px-4 py-10 font-roboto bg-white">
      {/* Section Heading */}
      <section id="client" className="flex flex-col items-center text-center">
        <span className="text-white bg-[#B20925] px-6 py-1 rounded-lg mb-4">
          Client Testimonials
        </span>

        <h1 className="text-3xl sm:text-5xl font-bold text-gray-900 mb-3">
          Worlds That Inspire
        </h1>

        <p className="text-gray-600 text-lg leading-relaxed max-w-2xl">
          Real feedback from businesses that trusted us to design, build, and
          deliver impactful digital experiences.
        </p>
      </section>

      {/* Main Flex Section */}
      <div className="flex flex-wrap justify-center items-center gap-10 mt-10 w-full">
        {/* Review Card */}
        <div className="flex flex-col items-center transition-all duration-500 ease-in-out">
          <div
            className="relative bg-white w-[330px] sm:w-[400px] md:w-[480px] h-[420px] shadow-lg border border-gray-200 rounded-xl p-6 flex flex-col justify-between"
            style={{
              filter: "drop-shadow(0px 12px 7px rgba(71,133,253,0.09))",
            }}
          >
            {/* Stars */}
            <div className="flex gap-2 justify-start">
              {Array(5)
                .fill()
                .map((_, i) => (
                  <img
                    key={i}
                    src={i < current.stars ? "Star.svg" : "gray.jpg"}
                    alt="Star"
                    className="w-5 h-5"
                  />
                ))}
            </div>

            {/* Review Text */}
            <p className="text-gray-800 text-lg leading-relaxed mt-6 italic">
              “{current.text}”
            </p>

            {/* Reviewer */}
            <div className="mt-6">
              <h3 className="font-bold text-lg text-gray-900">
                {current.name}
              </h3>
              <p className="text-gray-600">{current.location}</p>
            </div>
          </div>

          {/* Arrow Buttons */}
          <div className="flex justify-center items-center gap-6 mt-6">
            <button
              onClick={prevReview}
              className="rounded-full w-12 h-12 bg-[#B20925] flex justify-center items-center border-2 border-white ring ring-white ring-offset-2 ring-offset-[#B20925] hover:bg-[#8d071d] transition"
            >
              <img
                src="Left Arrow.png"
                alt="Left Arrow"
                className="w-6 h-6"
              />
            </button>

            <button
              onClick={nextReview}
              className="rounded-full w-12 h-12 bg-[#B20925] flex justify-center items-center border-2 border-white ring ring-white ring-offset-2 ring-offset-[#B20925] hover:bg-[#8d071d] transition"
            >
              <img
                src="Right Arrow.png"
                alt="Right Arrow"
                className="w-6 h-6"
              />
            </button>
          </div>
        </div>

        {/* Animated Layer / Image */}
        <div className="flex justify-center items-center">
          <img
            src="image.jpg"
            alt="Review From Worldwide"
            className="w-[320px] sm:w-[400px] md:w-[650px] h-auto rounded-lg"
          />
        </div>
      </div>
    </div>
  );
}
